import React from 'react';
import { HudIcon } from '../Icons/HudIcons';
import LongContentPopover from '../LongContentPopover/LongContentPopover';
import MultiSelect, { MultiSelectProps } from '../MultiSelect/MultiSelect';
import { Container } from './HeaderServiceFilter.styles';
import { IconButton } from '../DesignSystem/Components/IconButton';

export interface FilterProps {
  label: string;
  onClear: () => void;
}


export interface MultiSelectFilterProps extends FilterProps, MultiSelectProps {
  multiSelectLabel: string | React.ReactNode;
}

export const HeaderServiceFilter: React.FC<MultiSelectFilterProps> = (
  {
    multiSelectLabel,
    selectedOptions,
    mainGroupOption,
    options,
    searchTerm,
    optionReverseEllipsis,
    onChange,
    onSearch,
    onClose,
  }: MultiSelectFilterProps) => {

  return (
    <Container>
      <MultiSelect
        mainGroupOption={mainGroupOption}
        options={options}
        selectedOptions={selectedOptions}
        searchable
        optionReverseEllipsis={optionReverseEllipsis}
        searchTerm={searchTerm}
        renderButton={({ onClick }) => (
          <div className="label" onClick={onClick}>
            <LongContentPopover reverseEllipsis={optionReverseEllipsis}>
              {multiSelectLabel}
            </LongContentPopover>

            <IconButton icon="designSystem.chevronDown" />
          </div>
        )}
        onChange={onChange}
        onSearch={onSearch}
        onClose={onClose}
        position="bottom-start"
      />
    </Container>
  );
};
